import { LocalDate } from '@js-joda/core';

export const isLocalDate = (value: unknown): value is LocalDate => {
   return value instanceof LocalDate;
};
